import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
    selector: '[appClickAndDoubleClick]',
    standalone: false
})
export class ClickAndDoubleClickDirective {

  @Output() singleClick = new EventEmitter<MouseEvent>();
  @Output() doubleClick = new EventEmitter<MouseEvent>();

  private clickTimeout: any;
  private delay = 250; // ms
  private clickCount = 0;

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    this.clickCount++;

    if (this.clickCount === 1) {
      // Start single click timer
      this.clickTimeout = setTimeout(() => {
        if (this.clickCount === 1) {
          this.singleClick.emit(event);
        }
        this.clickCount = 0; // reset
      }, this.delay);
    }
  }

  @HostListener('dblclick', ['$event'])
  onDoubleClick(event: MouseEvent) {
    clearTimeout(this.clickTimeout);
    this.clickCount = 0; // reset
    this.doubleClick.emit(event);
  }
}
